import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = { class: "flex-fill" }
const _hoisted_4 = { class: "pt-3" }
const _hoisted_5 = { class: "table table-striped" }
const _hoisted_6 = { scope: "row" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "table table-striped" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.selectedAccount)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h4", _hoisted_3, _toDisplayString(_ctx.selectedAccount.name), 1),
          _cache[0] || (_cache[0] = _createElementVNode("button", { class: "btn btn-attention hide" }, "Hide", -1))
        ]),
        _createElementVNode("div", _hoisted_4, [
          _cache[10] || (_cache[10] = _createElementVNode("h5", null, "Current Usage Summary", -1)),
          _createElementVNode("table", _hoisted_5, [
            _cache[7] || (_cache[7] = _createElementVNode("thead", { class: "thead-dark" }, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, "Team"),
                _createElementVNode("th", null, "Charge date"),
                _createElementVNode("th", null, "Current usage")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teams, (t) => {
                return (_openBlock(), _createElementBlock("tr", null, [
                  _createElementVNode("td", null, _toDisplayString(t.name), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.dateString(t.budget.nextChargeTs * 1000)), 1),
                  _createElementVNode("td", null, _toDisplayString(t.budget.charges.toFixed(2)), 1)
                ]))
              }), 256))
            ]),
            _createElementVNode("tfoot", null, [
              _createElementVNode("tr", null, [
                _cache[1] || (_cache[1] = _createElementVNode("th", { scope: "row" }, "Subtotal", -1)),
                _cache[2] || (_cache[2] = _createElementVNode("th", { scope: "row" }, null, -1)),
                _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.totalCharges.toFixed(2)), 1)
              ]),
              (_ctx.selectedAccount.freeMonthlyCredit > 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [
                    _cache[3] || (_cache[3] = _createElementVNode("th", { scope: "row" }, "Free credit", -1)),
                    _cache[4] || (_cache[4] = _createElementVNode("th", { scope: "row" }, null, -1)),
                    _createElementVNode("td", null, _toDisplayString(-_ctx.freeCredit.toFixed(2)), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("tr", null, [
                _cache[5] || (_cache[5] = _createElementVNode("th", { scope: "row" }, "Total", -1)),
                _cache[6] || (_cache[6] = _createElementVNode("th", { scope: "row" }, null, -1)),
                _createElementVNode("td", null, _toDisplayString((_ctx.totalCharges-_ctx.freeCredit).toFixed(2)), 1)
              ])
            ])
          ]),
          (_ctx.records.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _cache[9] || (_cache[9] = _createElementVNode("h5", null, "Transaction History", -1)),
                _createElementVNode("table", _hoisted_9, [
                  _cache[8] || (_cache[8] = _createElementVNode("thead", { class: "thead-dark" }, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, "Operation"),
                      _createElementVNode("th", null, "Date"),
                      _createElementVNode("th", null, "Summary"),
                      _createElementVNode("th", null, "Amount")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.records, (r) => {
                      return (_openBlock(), _createElementBlock("tr", null, [
                        _createElementVNode("td", null, _toDisplayString(r.operation), 1),
                        _createElementVNode("td", null, _toDisplayString(_ctx.dateString(r.ts)), 1),
                        _createElementVNode("td", null, _toDisplayString(r.comment), 1),
                        _createElementVNode("td", null, _toDisplayString((r.amountCents / 100).toFixed(2)), 1)
                      ]))
                    }), 256))
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}